import { useCallback } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const LOGO_URL =
  "https://storage.readdy-site.link/project_files/ac2cc551-d4dd-4bc1-9142-393457b4e539/b541ae47-1bf4-433d-8cc6-b0741de80222_compressed_-1.webp";

export default function Footer() {
  const location = useLocation();
  const navigate = useNavigate();

  const handleHashNav = useCallback(
    (e: React.MouseEvent<HTMLAnchorElement>, hash: string) => {
      e.preventDefault();
      if (location.pathname === "/") {
        const el = document.getElementById(hash);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      } else {
        navigate("/");
        setTimeout(() => {
          const el = document.getElementById(hash);
          if (el) el.scrollIntoView({ behavior: "smooth" });
        }, 350);
      }
    },
    [location.pathname, navigate]
  );

  return (
    <footer className="bg-navy-900 text-white">
      <div className="w-full px-6 md:px-12 lg:px-16 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-3 mb-5">
              <img
                src={LOGO_URL}
                alt="JI&C 제이아이앤씨"
                className="h-11 w-auto rounded-md"
              />
              <div>
                <div className="font-hero text-xl">JI&amp;C</div>
                <div className="text-xs text-white/60">제이아이앤씨</div>
              </div>
            </div>
            <p className="text-sm leading-relaxed text-white/70">
              도장, 습식방수, 석공사, 실내건축 전문건설업<br />에폭시, 우레탄, 페인트 제조 · 도매 · 소매
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-white/90">사업분야</h4>
            <ul className="space-y-2 text-sm text-white/70">
              <li>
                <a
                  href="https://blog.naver.com/ksh1009000"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="hover:text-point-300 cursor-pointer transition-colors"
                >
                  에폭시 바닥공사
                </a>
              </li>
              <li>
                <a
                  href="https://blog.naver.com/PostList.naver?blogId=ksh1009000&from=postList&categoryNo=9&parentCategoryNo=9"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="hover:text-point-300 cursor-pointer transition-colors"
                >
                  우레탄 방수
                </a>
              </li>
              <li>
                <a
                  href="https://blog.naver.com/PostList.naver?blogId=ksh1009000&from=postList&categoryNo=13&parentCategoryNo=13"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="hover:text-point-300 cursor-pointer transition-colors"
                >
                  외벽도장
                </a>
              </li>
              <li>
                <a
                  href="https://blog.naver.com/PostList.naver?blogId=ksh1009000&from=postList&categoryNo=14"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="hover:text-point-300 cursor-pointer transition-colors"
                >
                  내부도장
                </a>
              </li>
              <li>
                <a
                  href="https://blog.naver.com/PostList.naver?blogId=ksh1009000&from=postList&categoryNo=27&parentCategoryNo=27"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="hover:text-point-300 cursor-pointer transition-colors"
                >
                  실내건축
                </a>
              </li>
              <li>
                <a
                  href="https://blog.naver.com/PostList.naver?blogId=ksh1009000&from=postList&categoryNo=29"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="hover:text-point-300 cursor-pointer transition-colors"
                >
                  석공사
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-white/90">바로가기</h4>
            <ul className="space-y-2 text-sm text-white/70">
              <li>
                <a
                  href="/#about"
                  onClick={(e) => handleHashNav(e, "about")}
                  className="hover:text-point-300 cursor-pointer transition-colors"
                >
                  회사소개
                </a>
              </li>
              <li>
                <Link to="/portfolio" className="hover:text-point-300 cursor-pointer transition-colors">
                  시공사례
                </Link>
              </li>
              <li>
                <a
                  href="/#blog"
                  onClick={(e) => handleHashNav(e, "blog")}
                  className="hover:text-point-300 cursor-pointer transition-colors"
                >
                  블로그
                </a>
              </li>
              <li>
                <Link to="/contact" className="hover:text-point-300 cursor-pointer transition-colors">
                  문의하기
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-white/90">연락처</h4>
            <ul className="space-y-3 text-sm text-white/70">
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-phone-line text-point-400"></i>
                </div>
                <span>051-727-0477 (평일 09:00 - 18:00)</span>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-mail-line text-point-400"></i>
                </div>
                <span>ksh10090000@hanmail.net</span>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-map-pin-line text-point-400"></i>
                </div>
                <span>부산시 기장군 장안읍 좌천로 20, 101호</span>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-global-line text-point-400"></i>
                </div>
                <a
                  href="https://www.jinc1.com"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="hover:text-point-300 cursor-pointer"
                >
                  www.jinc1.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-award-line text-point-400"></i>
                </div>
                <span>전문건설업 등록 · 장애인기업 인증</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="w-full px-6 md:px-12 lg:px-16 py-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-white/50">
            © 2026 JI&amp;C 제이아이앤씨. All rights reserved. | 사업자등록번호 610-86-02492
          </p>
          <div className="flex items-center gap-4 text-xs text-white/50">
            <Link to="/privacy" className="hover:text-white cursor-pointer">개인정보처리방침</Link>
            <span>·</span>
            <Link to="/terms" className="hover:text-white cursor-pointer">이용약관</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}